import findIndexToRemove from './findIndexToRemove';
import cloneDeep from 'lodash/cloneDeep';

const analyzeAvailability = (removedSet, existingAvailability) => {
    if (typeof existingAvailability[0] === 'string') {
        return false;
    }
    else {
        let modifiedExistingAvailability = cloneDeep(existingAvailability);
        removedSet.forEach(timeBlock => {
            let indexToRemove = findIndexToRemove([timeBlock], modifiedExistingAvailability);
            modifiedExistingAvailability.splice(indexToRemove, 1);
        });
        return (modifiedExistingAvailability.length === 0 || modifiedExistingAvailability.length === existingAvailability.length) ? false : modifiedExistingAvailability;
    };
};

export default analyzeAvailability;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/analyzeAvailability.js